<div class="main-container">
  <!-- Left Panel -->
  <div class="left-panel" *ngIf="currentView !== 'loading'">
    <div class="left-panel-content" [class.search-box-blurred]="arktabaccess"
      [ngStyle]="{'pointer-events': isAnyLoaderActive ? 'none' : 'auto', 'opacity': isAnyLoaderActive ? '0.6' : '1'}">
      <div class="logo-section">
        <div class="askme-logo">
          <div class="chatbot-icon-small" style="cursor: pointer;" (click)="navigateToLanding()">
          </div>
        </div>
      </div>
      <div class="icons-section">
        <div class="icon-item" (click)="navigateToLanding()">
          <div class="new-chat-icon-nav"></div>
          <div class="tooltip">New Chat</div>
        </div>
        <div class="icon-item" [class.active]="isChatHistoryOpen" (click)="toggleChatHistory()">
          <div class="chats-icon"></div>
          <div class="tooltip">Chat History</div>
        </div>
        <div class="icon-item" [class.active]="isSavedQuestionsOpen" (click)="toggleSavedSelections()">
          <div class="stars-icon"></div>
          <div class="tooltip">Saved Questions</div>
        </div>
      </div>
      <div class="home-section">
        <!-- <div class="icon-item" [class.animating]="isDiagnosticAnimating" title="Diagnostic" (click)="viewOnline()">
          <div class="diagnostic-icon"></div>
        </div> -->
        <div class="icon-item" [class.active]="isChatSearchOpen" (click)="toggleChatSearch()">
        <div class="search-icon-nav"></div>
          <div class="tooltip">Search Chats</div>
        </div>
        <div class="icon-item" (click)="goToLandingPage()">
          <div class="home-icon"></div>
          <div class="tooltip">Home</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Chat Search Overlay -->
  <div class="chat-search-overlay" *ngIf="isChatSearchOpen" (click)="closeChatSearch()"></div>
  <div class="chat-search-panel" *ngIf="isChatSearchOpen">
    <div class="search-panel-header">
      <div class="search-input-wrapper">
        <div class="search-icon-nav-inner"></div>
        <input type="text" id="chat-search-input"
               placeholder="Search previous chats..." 
               [value]="chatSearchQuery"
               (input)="onSearchInput($event)"
               (keydown)="onSearchKeydown($event)"
               autocomplete="off" />
        <div class="clear-search" *ngIf="chatSearchQuery" (click)="chatSearchQuery = ''; searchDebounce$.next('')">×</div>
      </div>
      <div class="search-close" (click)="closeChatSearch()">Esc</div>
    </div>
    
    <div class="search-results-container">
      <div class="empty-state" *ngIf="!filteredSearchChats.length && chatSearchQuery">
        No chats found matching "{{chatSearchQuery}}"
      </div>
      <div class="empty-state" *ngIf="!chatSearchQuery">
        Type to search across your chat history.
      </div>
      
      <div class="search-result-item" 
           *ngFor="let result of filteredSearchChats; let i = index; trackBy: trackByIndex"
           [class.active]="i === searchSelectedIndex"
           (click)="selectSearchResult(result)"
           (mouseenter)="searchSelectedIndex = i">
        <div class="result-title" [innerHTML]="result.title | highlightSearch:chatSearchQuery"></div>
        <div class="result-snippet" [innerHTML]="result.snippet | highlightSearch:chatSearchQuery"></div>
        <div class="result-footer">
          <div class="result-date">{{ result.date | date:'mediumDate' }}</div>
          <div class="result-badges">
            <div class="badge badge-star tooltip-wrapper" *ngIf="result.isStarred">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="badge-icon">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
              <div class="askme-custom-tooltip"><span class="d-title">Starred</span></div>
            </div>
            <div class="badge badge-like tooltip-wrapper" *ngIf="result.isLiked === true">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="badge-icon">
                <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>
              </svg>
              <div class="askme-custom-tooltip"><span class="d-title">Liked</span></div>
            </div>
            <div class="badge badge-dislike tooltip-wrapper" *ngIf="result.isLiked === false">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="badge-icon">
                <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-3"></path>
              </svg>
              <div class="askme-custom-tooltip"><span class="d-title">Disliked</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Landing View -->
  <div class="landing-container" *ngIf="currentView === 'landing'">
    <div class="main-content">
      <div class="client-logo-landing" *ngIf="clientLogo">
        <img [src]="clientLogo" alt="Client Logo" class="client-logo-img">
      </div>
      <div class="content-wrapper">
        <div class="welcome-section">
          <div class="welcome-header">
            <div class="logo-container">
              <div class="chatbot-icon"></div>
            </div>
            <h1 class="welcome-text">How can I help you?</h1>
          </div>
          <!-- Search Box -->
          <div class="askme-container" style="display: flex; flex-direction: column; width: 100%; align-items: center; max-height: 100%; position: relative; z-index: 1000;">
            <!-- MULTI QUESTION UI -->
            <div class="multi-question-panel landing-mode-popup" *ngIf="isMultiQuestionMode">
              <div class="mq-header">
                <div style="display: flex; align-items: center; gap: 8px;">
                  <span>Batch Questions</span>
                </div>
                <div class="mq-close" (click)="toggleMultiQuestionMode()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                </div>
              </div>
              <div class="mq-list">
                <div class="mq-item" *ngFor="let q of multiQuestionList; let i = index; trackBy: trackByIndex">
                  <span class="mq-number">{{i + 1}}.</span>
                  <input type="text" [value]="multiQuestionList[i]" (input)="multiQuestionList[i] = $any($event.target).value" placeholder="Enter question..." class="mq-input" (keydown.enter)="addMultiQuestion()">
                  <div class="mq-remove" (click)="removeMultiQuestion(i)" *ngIf="multiQuestionList.length > 1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                  </div>
                </div>
              </div>
              <div class="mq-actions">
                <input type="file" #excelUpload style="display: none" accept=".xlsx, .xls, .csv" (change)="onBatchExcelUpload($event)">
                <div style="display: flex; gap: 8px;">
                  <button class="mq-upload-btn" (click)="promptForTemplate(excelUpload)">Upload Excel</button>
                  <button class="mq-add-btn" (click)="addMultiQuestion()">+ Add Question</button>
                </div>
                <button class="mq-send-btn" [disabled]="!hasValidMultiQuestions" (click)="sendMultiQuestions()">Send All ({{multiQuestionList.length}})</button>
              </div>

              <!-- Template Download Prompt Overlay -->
              <div class="template-prompt-overlay" *ngIf="showTemplatePrompt">
                <div class="template-prompt-card">
                  <div class="prompt-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8600cd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
                  </div>
                  <h4>Download Template?</h4>
                  <p>Use our standard format for a seamless upload.</p>
                  <div class="template-prompt-actions">
                    <button class="btn-outline" (click)="handleTemplateSelection(true)">Yes, Download</button>
                    <button class="btn-primary" (click)="handleTemplateSelection(false)">Skip & Upload</button>
                  </div>
                  <div class="prompt-close" (click)="showTemplatePrompt = false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  </div>
                </div>
              </div>
            </div>

            <div class="search-box" [class.search-box-blurred]="arktabaccess"
              [ngStyle]="{'pointer-events': isAnyLoaderActive ? 'none' : 'auto', 'opacity': isAnyLoaderActive ? '0.6' : '1'}">
              <form [formGroup]="searchForm" (ngSubmit)="onSearchSubmit()" class="search-form">
                <div class="search-input-wrapper">
                <input type="text" formControlName="query" 
                       [placeholder]="isDictating && activeDictationTarget === 'main' ? 'Listening...' : 'Ask me anything...'" 
                       class="search-input"
                       [attr.disabled]="isAnyLoaderActive ? true : null" />
                
                <!-- Multi Question Toggle -->
                <div class="dictate-icon-wrapper multi-q-toggle" (click)="toggleMultiQuestionMode()">
                  <div class="dictate-icon" [class.recording]="isMultiQuestionMode">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-list-todo"><rect x="3" y="5" width="6" height="6" rx="1"/><path d="m3 17 2 2 4-4"/><path d="M13 6h8"/><path d="M13 12h8"/><path d="M13 18h8"/></svg>
                  </div>
                  <div class="askme-custom-tooltip">
                    <span class="d-title">Batch Questions</span>
                  </div>
                </div>

                <!-- Dictation Mic -->
                <div class="dictate-icon-wrapper" *ngIf="isSpeechSupported">
                  <div class="dictate-icon" 
                       [class.recording]="isDictating && activeDictationTarget === 'main'"
                       (click)="toggleDictation('main')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-mic"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" x2="12" y1="19" y2="22"/></svg>
                  </div>
                  <div class="askme-custom-tooltip">
                    <span class="d-title">Dictate</span>
                    <span class="d-shortcut">Ctrl + Shift + D</span>
                  </div>
                </div>
              </div>
              <div class="send-icon-wrapper">
                <button type="submit" class="send-button">
                  <div class="send-arrow"></div>
                </button>
                <div class="askme-custom-tooltip">
                  <span class="d-title">Send</span>
                  <span class="d-shortcut">Enter</span>
                </div>
              </div>
            </form>
          </div>
        </div>
        </div>
        <div class="suggestions-wrapper">
          <!-- Key Questions -->
          <div class="key-questions-container">
            <div class="header">
              <div class="header-content">
                <div class="title-section active">
                  <h2 class="title">
                    <span class="title-light">Key</span> <span class="title-bold">Questions</span>
                  </h2>
                </div>
                <div class="tabs">
                  <div class="tab-icon" [class.active]="!isListView" (click)="toggleView()">
                    <div class="grid-icon"></div>
                  </div>
                  <div class="tab-icon" [class.active]="isListView" (click)="toggleView()">
                    <div class="list-icon"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="questions-list" [class.grid-view]="!isListView" [class.list-view]="isListView">
              <!-- List View -->
              <ng-container *ngIf="isListView">
                <div class="question-item" *ngFor="let question of questions; trackBy: trackByIndex"
                  (click)="sendKeyQuestion(question)">
                  <div class="arrow-icon">
                    <div class="chevron-left"></div>
                  </div>
                  <p class="key-question-text">{{ question }}</p>
                </div>
              </ng-container>

              <!-- Grid View -->
              <div class="questions-grid" *ngIf="!isListView">
                <div class="question-card" *ngFor="let question of questions; trackBy: trackByIndex; let i = index"
                  (click)="sendKeyQuestion(question)">
                  <div class="card-image" [style.background-image]="getGridImage(i)"></div>
                  <p class="card-text">{{ truncateText(question, 150) }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="powered-by" [class.powered-by-glow]="arktabaccess">
            <span class="powered-text">Powered by</span>
            <div class="kai-logo"></div>
          </div>
          <div class="explorer-logo"></div>
        </div>
      </div>
    </div>
</div>
<!-- Chat Expand End -->
  <div class="chat-container" *ngIf="currentView === 'chat'">
    <div class="scroll-target-loader-overlay" *ngIf="isScrollingToTarget">
      <div class="loader-wrapper">
        <div class="loader"></div>
      </div>
    </div>
    <!-- Right Side Content Wrapper -->
    <div class="output-content-wrapper">
      <!-- Output Area -->
      <!-- Scrollable content area -->
      <div class="scrollable-content" #chatHistoryScroll (scroll)="onChatScroll($event)">
        <div class="output-area" #outputArea>
          <div *ngFor="let block of chatPreviewBlocks; let i = index; trackBy: trackByIndex" class="message-block-group"
            [id]="'message-' + block.messageId">

            <div class="question-display" *ngIf="block.question">
              <div class="question-header">
                <h2 class="question-title">{{ truncateText(block.question, 250) }}</h2>
              </div>
            </div>

            <div class="output-box" *ngIf="block.messageId === selectedMessageId || block.fullAnswer">
              <!-- Multi-View Agent Switcher -->
              <div class="multi-view-container" *ngIf="(block.availableViews || availableViews || []).length > 0">
                <div class="view-pill" *ngFor="let view of (block.availableViews || availableViews || []); trackBy: trackByIndex"
                  [class.active]="(block.mcode || mcode) === view.mcode"
                  [class.disabled-tab]="isHistorySaving && (block.mcode || mcode) !== view.mcode && i === chatPreviewBlocks.length - 1"
                  [class.just-enabled]="isTabJustEnabled && (block.mcode || mcode) !== view.mcode && i === chatPreviewBlocks.length - 1"
                  [title]="'Switch to ' + view.name" (click)="switchAnalysisView(view, block)">
                  <div class="view-icon"></div>
                  <span class="view-text">{{ view.name }}</span>
                </div>
              </div>

              <!-- Chart/Output Area -->
              <div [ngClass]="showSnapshot && !isFailedCase(block) ? 'chart-snapshot' : 'chart'"
                [class.trend-view-active]="block.isTrendActive">
                <div class="outputData-config" [ngClass]="{ outputGap: block.isIndex }"
                  *ngIf="!isSnapshotVisible(block) && !isFailedCase(block)">
                  <div class="outputData-config-Block1-container">
                    <div class="significanceContainer" *ngIf="!block.isIndex">
                      <div class="significanceMainContainer"
                        *ngIf="block.is_sigtesting && block.is_Time_Period_Present">
                        <div class="significanceLabel">Significance</div>
                        <div class="significanceDropDown significance">
                          <div class="significance-block" (click)="togglePanel('significance', block)">
                            <ng-container *ngIf="block.SignificanceVsReference">
                              <div class="sigNameContainer"
                                [title]="(block.DefaultSampleSize || 'None') + ' : ' + replacePipe(block.SignificanceVsReference)">
                                <div class="weighted-text-block">
                                  {{ block.DefaultSampleSize || 'None' }} :
                                  {{ replacePipe(block.SignificanceVsReference) }}
                                </div>
                              </div>
                            </ng-container>
                            <ng-container *ngIf="!block.SignificanceVsReference">
                              <div class="sigNameContainer" title="{{ block.DefaultSampleSize || 'None' }}">
                                <div class="weighted-text-block">
                                  {{ block.DefaultSampleSize || 'None' }}
                                </div>
                              </div>
                            </ng-container>
                            <div class="arrow-weighted-block">
                              <div class="arrowToggle arrowToggleIcon"
                                [ngClass]="{ arrowCollapsedIcon: block.sampleSizeDropdown }">
                              </div>
                            </div>
                          </div>
                          <div class="sampleSize-sub-items" *ngIf="block.sampleSizeDropdown">
                            <div *ngFor="let list of (block.SampleSizeList || SampleSizeList); trackBy: trackByIndex" class="sub-items-block"
                              (click)="SampleSizeDropDownClick(list.key, block)" [ngClass]="{
                            disabled:
                              (list.key === 'Pairwise' && ((block.isDisablePairWise !== undefined ? block.isDisablePairWise : isDisablePairWise) || block.isTranspose)) ||
                              (list.key === 'Reference' && ((block.isDisableReference !== undefined ? block.isDisableReference : isDisableReference) || block.isTranspose))
                          }">
                              <div class="sample_size_block" [title]="list.key">
                                <div class="sub-items-names">{{ list.key }}</div>
                              </div>
                              <div class="side-panel-arrow-sig" *ngIf="list.key === 'Reference'">
                                <div class="arrowToggle metric-list-open"></div>
                              </div>
                            </div>
                          </div>
                          <div class="Reference-sub-items-significance" *ngIf="block.isReference">
                            <div class="reference-panel-search">
                              <input type="text" placeholder="Search" style="width: 100%" [(ngModel)]="block.searchTextLevel1"
                                autocomplete="off" name="searchTextLevel1" />
                              <div class="search-icon">
                                <div class="search-icon-image"></div>
                              </div>
                            </div>
                            <div *ngFor="let list of (block.IndexData || IndexData); trackBy: trackByIndex" class="reference-sub-items-block" [ngClass]="{
                            hide: !list.Child.toLowerCase().includes(
                              (block.searchTextLevel1 || '').toLowerCase()
                            )
                          }" (click)="referenceDropDownClickIndexSignificance(list.Child, block)">
                              <div class="reference-icon-container">
                                <div class="radio-icon" [ngClass]="{
                                'radio-icon-active': isSelectedSignificance(list.Child, block)
                              }"></div>
                              </div>
                              <div class="reference-option-container" title="{{ replacePipe(list.Child) }}">
                                <div class="sub-items-names">
                                  {{ replacePipe(list.Child) }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="confidenceLevelContainer" *ngIf="(block.is_confidenceLevel || is_confidenceLevel).length > 0 && !block.isIndex">
                      <div class="confidenceLevelMainContainer" *ngIf="block.is_Time_Period_Present">
                        <div class="confidanceLabel">Confidence Level</div>
                        <div class="confidanceDropDown confidance">
                          <div class="confidence-block" [ngClass]="{ itemDisable: block.DefaultSampleSize == 'None' }"
                            (click)="togglePanel('confidence', block)">
                            <div class="confidence-text-block"
                              [title]="block.DefaultSampleSize == 'None' ? 'None' : (block.DefaultConfidenceLevel || '95%')">
                              {{ block.DefaultSampleSize == 'None' ? 'None' : (block.DefaultConfidenceLevel || '95%') }}
                            </div>
                            <div class="arrow-weighted-block arrowBlock">
                              <div class="arrowToggle arrowToggleIcon"
                                [ngClass]="{ arrowCollapsedIcon: block.confidenceLevelDropDown }"></div>
                            </div>
                          </div>
                          <div class="confidence-sub-items" *ngIf="block.confidenceLevelDropDown">
                            <div *ngFor="let list of (block.is_confidenceLevel || is_confidenceLevel); trackBy: trackByIndex" class="sub-items-block"
                              (click)="confidenceDropDownClick(list.key, block)" [title]="list.key">
                              <div class="sub-items-names">{{ list.key }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="ReferenceLevelContainer" *ngIf="block.isIndex">
                      <div class="ReferenceLevelMainContainer">
                        <div class="ReferenceLabel">Reference</div>
                        <div class="ReferenceDropDown reference">
                          <div class="Reference-block itemDisable">
                            <div class="Reference-text-block-main">
                              <div class="Reference-text-block" title="{{ block.DefaultReferenceLevel || 'None' }}">
                                {{ block.DefaultReferenceLevel || 'None' }}
                              </div>
                            </div>
                            <div class="arrow-weighted-block referenceArrowBlock">
                              <div class="arrowToggle arrowToggleIcon"
                                [ngClass]="{ arrowCollapsedIcon: block.referenceLevelDropDown }">
                              </div>
                            </div>
                          </div>
                          <div class="Reference-sub-items" *ngIf="block.referenceLevelDropDown">
                            <div class="reference-panel-search">
                              <input type="text" placeholder="Search" style="width: 100%" [(ngModel)]="block.searchTextLevel1"
                                autocomplete="off" name="searchTextLevel1" />
                              <div class="search-icon">
                                <div class="search-icon-image"></div>
                              </div>
                            </div>
                            <div *ngFor="let list of (block.IndexData || IndexData); trackBy: trackByIndex" class="reference-sub-items-block" [ngClass]="{
                      hide: !list.Child.toLowerCase().includes(
                        (block.searchTextLevel1 || '').toLowerCase()
                      )
                    }" (click)="referenceDropDownClick(list.Child, block)">
                              <div class="reference-icon-container">
                                <div class="radio-icon" [ngClass]="{
                          'radio-icon-active': isSelected(list.Child, block)
                        }"></div>
                              </div>
                              <div class="reference-option-container" title="{{ replacePipe(list.Child) }}">
                                <div class="sub-items-names">
                                  {{ replacePipe(list.Child) }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="DataContainer"
                      *ngIf="(getMcode(block) === 2 || getMcode(block) === 3) && !isSnapshotVisible(block)">
                      <div class="dataMainContainer">
                        <div class="dataDropDownContainer dataDropdown">
                          <div class="data-block-main" (click)="togglePanel('datadropdown', block)">
                            <div class="sigNameContainer" [title]="block.DefaultDataDropDown || 'Data'">
                              <div class="weighted-text-block">
                                {{ block.DefaultDataDropDown || 'Data' }}
                              </div>
                            </div>

                            <div class="arrow-weighted-block">
                              <div class="arrowToggle arrowToggleIcon"
                                [ngClass]="{ arrowCollapsedIcon: block.dataDropDown }">
                              </div>
                            </div>
                          </div>
                          <div class="data-sub-items" *ngIf="block.dataDropDown">
                            <div *ngFor="let list of dataDropDownList; trackBy: trackByIndex" class="sub-items-block"
                              (click)="toggleDataBlock(list, block)">
                              <div class="sample_size_block" [title]="list">
                                <div class="sub-items-names">{{ list }}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Chart Switcher & Metadata Context -->

                    <div class="weightContainer"
                      *ngIf="(getMcode(block) === 2 || getMcode(block) === 3) && !isSnapshotVisible(block)">
                      <div class="weightMainContainer" [ngClass]="{ 'itemDisable': isAnyLoaderActive }">
                        <div class="weightLabel">Weight</div>
                        <div class="weightDropDown weight">
                          <div class="weight-block" (click)="togglePanel('weight', block)">
                            <div class="weight-text-block-main">
                              <div class="weight-text-block" title="{{ block.DefaultWeight }}">
                                {{ block.DefaultWeight }}
                              </div>
                            </div>
                            <div class="arrow-weighted-block referenceArrowBlock">
                              <div class="arrowToggle arrowToggleIcon"
                                [ngClass]="{ arrowCollapsedIcon: block.weightDropDown }"></div>
                            </div>
                          </div>
                          <div class="weight-sub-items"
                            *ngIf="block.weightDropDown && WeightDropDownList && WeightDropDownList.length >= 1">
                            <div *ngFor="let list of (block.WeightDropDownList || WeightDropDownList); trackBy: trackByIndex" class="weight-sub-items-block"
                              (click)="weightDropDownClick(list.Label, list.responseCode, block)">
                              <div class="weight-option-container">
                                <div class="sub-items-names" title="{{ list.Label }}">
                                  {{ list.Label }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="BaseContainer"
                      *ngIf="(getMcode(block) === 2 || getMcode(block) === 3) && !isSnapshotVisible(block)">
                      <div class="BaseMainContainer" [ngClass]="{ 'itemDisable': isAnyLoaderActive }">
                        <div class="BaseLabel">Base</div>
                        <div class="BaseDropDown Base">
                          <div class="Base-block" (click)="togglePanel('Base', block)">
                            <div class="Base-text-block-main">
                              <div class="Base-text-block" title="{{ block.DefaultBase }}">
                                {{ block.DefaultBase }}
                              </div>
                            </div>
                            <div class="arrow-Base-block referenceArrowBlock">
                              <div class="arrowToggle arrowToggleIcon"
                                [ngClass]="{ arrowCollapsedIcon: block.baseDropDown }"></div>
                            </div>
                          </div>
                          <div class="Base-sub-items" *ngIf="block.baseDropDown">
                            <div class="Base-sub-items-block" (click)="toggleActiveBlock('total_base', block)">
                              <div class="Base-option-container">
                                <div class="sub-items-names" title="Total Base">
                                  Total Base
                                </div>
                              </div>
                            </div>
                            <div class="Base-sub-items-block" [ngClass]="{ 'answer-base-disabled': !enableAnswerBase }"
                              (click)="enableAnswerBase && toggleActiveBlock('answer_base', block)">
                              <div class="Base-option-container">
                                <div class="sub-items-names" title="Answer Base">
                                  Answer Base
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="ChartMainContainer">
                      <ng-container *ngIf="getMcode(block) === 1 || getMcode(block) === 2 || getMcode(block) === 3">
                        <div class="iconsContainerMain" (mouseover)="block.showMainTooltip = true"
                          (mouseleave)="block.showMainTooltip = false">
                          <div class="iconsContainer">
                            <div class="tablePreview" [ngClass]="{ bg: block.isTableClick }"
                              (click)="onTableIconClick(block)"
                              (mouseover)="block.showMainTooltip = false; $event.stopPropagation()">
                              <div class="iconContainer">
                                <div class="output-icon"
                                  [ngClass]="block.isTableClick ? 'table-icon-white' : 'table-icon'">
                                </div>
                              </div>
                            </div>

                            <div class="tooltipMain" (mouseover)="onChartIconMouseOver('stack', $event, block)"
                              (mouseleave)="onChartIconMouseLeave('stack', block)">


                              <div class="columnChartPreview" #preview
                                [ngClass]="{ bg: block.isVerticalStackChartClick && !block.disableStackChart,itemDisable: block.disableStackChart}"
                                (click)="onVerticalStackBarChartIconClick('column', block)">
                                <div class="iconContainer">
                                  <div class="output-icon"
                                    [ngClass]="block.isVerticalStackChartClick ? 'horizontal-bar-icon-white': 'horizontal-bar-icon'">
                                  </div>
                                </div>
                              </div>
                              <div class="chart-tooltip" *ngIf="block.showStackTooltip && block.disableStackChart">
                                <ul>
                                  <ng-container *ngFor="let item of StackChartToolTip; trackBy: trackByIndex">
                                    <li [innerHTML]="item"></li>
                                  </ng-container>
                                </ul>
                              </div>
                            </div>

                            <div class="tooltipMain" *ngIf="getMcode(block) != 2"
                              (mouseover)="onChartIconMouseOver('line', $event, block)"
                              (mouseleave)="onChartIconMouseLeave('line', block)">
                              <div class="lineChartPreview" [ngClass]="{
                          bg: block.isLineChartClick && !block.disableLineChart,
                          itemDisable: block.disableLineChart
                        }" (click)="onTrendChartIconClick(block)">
                                <div class="iconContainer">
                                  <div class="output-icon" [ngClass]="
                              block.isLineChartClick
                                ? 'trend-icon trend-active'
                                : 'trend-icon'
                            "></div>
                                </div>
                              </div>
                              <div class="chart-tooltip" *ngIf="block.showLineTooltip && block.disableLineChart">
                                <ul>
                                  <ng-container *ngFor="let item of LineChartToolTip; trackBy: trackByIndex">
                                    <li [innerHTML]="item"></li>
                                  </ng-container>
                                </ul>
                              </div>
                            </div>
                            <div class="tooltipMain" (mouseover)="onChartIconMouseOver('bar', $event, block)"
                              (mouseleave)="onChartIconMouseLeave('bar', block)">
                              <div class="GrpVertical" [ngClass]="{
                          bg: block.isVerticalGroupBarChartClick || block.isVerticalBarChartClick,
                          itemDisable: !block.isChartView
                        }" (click)="VerticalChartClick('column', block)">
                                <div class="iconContainer">
                                  <div class="output-icon grp-bar-icon" [ngClass]="
                              block.isVerticalGroupBarChartClick || block.isVerticalBarChartClick
                                ? 'grp-bar-icon-white'
                                : 'grp-bar-icon'
                            "></div>
                                </div>
                              </div>
                              <div class="chart-tooltip" *ngIf="block.showBarTooltip && !block.isChartView">
                                <ul>
                                  <ng-container *ngFor="let item of BarChartToolTip; trackBy: trackByIndex">
                                    <li [innerHTML]="item"></li>
                                  </ng-container>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div class="chart-tooltip"
                            *ngIf="block.showMainTooltip && (block.isIndex || !block.isChartView) && !block.showStackTooltip && !block.showLineTooltip && !block.showBarTooltip">
                            <ul>
                              <ng-container *ngFor="let item of GeneralToolTip; trackBy: trackByIndex">

                                <li [innerHTML]="item"></li>
                              </ng-container>
                            </ul>
                          </div>
                        </div>
                      </ng-container>
                    </div>

                    <div class="TotalTransposeContainer transpose-na-wrapper"
                      *ngIf="getMcode(block) === 2 || getMcode(block) === 3">
                      <div class="Totaltranpose-block transpose-block" [ngClass]="{
                          itemDisable: block.isLineChartClick || block.isTotal || block.isPairWise || block.isIndex
                        }" (click)="OnTransposeClick(block)" *ngIf="block.is_TransposeBtn !== undefined ? block.is_TransposeBtn : is_TransposeBtn">
                        <div class="checkbox-icon" [ngClass]="{ 'checkbox-icon-active': block.isTranspose }"></div>
                        <div class="btn-text">Transpose</div>
                      </div>
                    </div>
                  </div>

                  <div class="ribbon-actions-container">
                    <!-- Trend Switcher Toggle -->
                    <div class="trend-icon-button-wrapper" *ngIf="getMcode(block) === 1">
                      <div class="trend-container" [class.active]="block.isTrendActive" (click)="onTrendToggle(block)"
                        [title]="block.isTrendActive ? 'Switch to Normal Chart' : 'Switch to Trend View'">
                        <div class="trend-icon" [style.background-image]="block.isTrendActive ? 'url(assets/images/common/aesthetics/crosstab_verticalgroup_bar_InActive.svg)' : ''"></div>
                        <span class="trend-text">{{ block.isTrendActive ? 'Standard' : 'Trendline' }}</span>
                      </div>
                    </div>

                    <div class="exports-popup-container" #exportsPopup (click)="$event.stopPropagation()"
                      *ngIf="isActionsVisible(block)">
                      <div class="exports-popup-container-img-block"
                        [ngClass]="{ 'exports-popup-container-img-block-Active' : block.isExportspopup}"
                        (click)="Exportspopup($event, block)">
                      </div>
                      <div class="setting-container showPanel"
                        [ngStyle]="{right:isInsightsBtnEnabled && is_AI_Integration?'8.5%':'1%'}"
                        *ngIf="block.isExportspopup">
                        <div class="setting-blocks editablePPTSettings" *ngIf="getMcode(block)!=1" [ngClass]="{ 'disabled':
                              !(pptExport &&
                              (block.isVerticalGroupBarChartClick ||
                                block.isVerticalBarChartClick ||
                                block.isVerticalStackChartClick ||
                                block.isLineChartClick ||
                                isSnapshotVisible(block)))
                            }" (click)="handlePPTExportClick($event, block)">
                          <div class="setting-block-icon ppt-icon"></div>
                          <div class="setting-block-name">PPT</div>
                        </div>
                        <div class="setting-blocks editablePPTSettings" *ngIf="getMcode(block)==1"
                          (click)="handlePPTExportClick($event, block)">
                          <div class="setting-block-icon ppt-icon"></div>
                          <div class="setting-block-name">PPT</div>
                        </div>
                        <div class="setting-blocks excelexportSettings"
                          [ngClass]="{'disabled': !isActionsVisible(block)}" (click)="handleExportClick($event, block)">
                          <div class="setting-block-icon excel-icon"></div>
                          <div class="setting-block-name">Excel</div>
                        </div>
                      </div>
                    </div>

                    <!-- Selection Summary Button -->
                    <button class="selection-summary-btn" *ngIf="isActionsVisible(block)"
                      (click)="SelectionsummaryCollapseExpand('SelectionSummary', block)">
                      Selection Summary
                    </button>
                  </div>
                </div>

                <!-- Table and Chart Output Wrapper -->
                <div [ngClass]="isSnapshotVisible(block) ? 'table-output-wrapper-snapshot' : 'table-output-wrapper'"
                  *ngIf="block.messageId === selectedMessageId || block.fullAnswer"
                  [attr.data-message-id]="block.messageId">
                  <div class="table-output" *ngIf="!isSnapshotVisible(block) && !isFailedCase(block) && !block.isAnalysisSwitching"
                    [key]="block.messageId + '_' + getMcode(block)">
                    <!-- Table with its own soft entrance animation -->
                    <div class="table-fade-wrapper output-fade-in" [class.is-closing]="block.isTableClosing"
                      *ngIf="isTableVisible(block) || block.isTableClosing">
                      <div class="table-inner">
                        <app-table-ouput #tableOutputComponent
                          *ngIf="getOutputData(block) && getOutputData(block).Row && getOutputData(block).Column"
                          [isFromAskMe]="true"
                          [data]="getOutputData(block)" 
                          [isTranspose]="block.isTranspose ?? false"
                          [isTotalBase]="block.isTotalBase ?? true"
                          [isAnswerBase]="block.isAnswerBase ?? false"
                          [isSampleSize]="block.isSampleSize ?? false"
                          [selectedDataFormat]="block.selectedDataFormat || 'Respondent Level'"
                          [isWeightedLabel]="block.isWeightedLabel ?? false"
                          [DefaultConfidenceLevel]="block.DefaultSampleSize == 'None' ? 'None' : (block.DefaultConfidenceLevel || '95%')"
                          [SignificanceVsReference]="block.SignificanceVsReference || ''"
                          [isWeightedNumerator]="block.isWeightedNumerator ?? false"
                          [isUnWeightedNumerator]="block.isUnWeightedNumerator ?? false"
                          [insufficientBase]="insufficientBase" [LowBase]="LowBase"
                          [DefaultSampleSize]="block.DefaultSampleSize || 'None'"
                          [isSampleSizeBlock]="block.isSampleSizeBlock ?? false"
                          [isWeightedSampleBlock]="block.isWeightedSampleBlock ?? false"
                          [isBrandAnalysis]="block.isBrandAnalysis ?? false"
                          [isPairWise]="block.isPairWise ?? false" [threshold]="threshold"
                          [selectedIndex]="selectedIndex" [isIndex]="block.isIndex ?? false"
                          [selectedWeight]="block.selectedWeight || 'Unweighted'"></app-table-ouput>
                      </div>
                    </div>

                    <!-- Chart Components Wrapper with premium liquid-smooth reveal -->
                    <div class="chart-area-container" [class.is-closing]="block.isChartClosing"
                      *ngIf="isChartVisible(block) || block.isChartClosing" style="position: relative;">
                      
                      <!-- Copy Chart Button inside chart area -->
                      <div class="copy-icon-wrapper tooltip-wrapper" style="position: absolute; bottom: 15px; right: 15px; z-index: 10;">
                        <div class="icon-button copy-icon" [class.copy-success-pulse]="copiedChartId === block.messageId" (click)="handleCopyChartClick($event, block)" style="width: 33px; height: 33px; border-radius: 6px; display: flex; align-items: center; justify-content: center; border: 1px solid rgba(0,0,0,0.05); box-shadow: 0 2px 4px rgba(0,0,0,0.05); transition: all 0.3s ease;">
                          <svg *ngIf="copiedChartId !== block.messageId && isCopyingId !== block.messageId" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="copy-svg-icon" style="pointer-events: none;">
                            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                          </svg>
                          <!-- Loading Spinner Icon -->
                          <svg *ngIf="isCopyingId === block.messageId" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="copy-svg-icon spin-animation" style="pointer-events: none;">
                            <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"></path>
                          </svg>
                          <!-- Copied Checkmark Icon -->
                          <svg *ngIf="copiedChartId === block.messageId && isCopyingId !== block.messageId" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="copy-svg-icon copied copied-checkmark" style="pointer-events: none; transform-origin: center;">
                            <polyline points="20 6 9 17 4 12"></polyline>
                          </svg>
                        </div>
                        <div class="askme-custom-tooltip feedback-tooltip">
                          <span class="d-title">{{ copiedChartId === block.messageId ? 'Copied!' : 'Copy chart' }}</span>
                        </div>
                      </div>

                      <div class="chart-area-inner">
                        <app-vertical-group-bar-chart *ngIf="isChartType(block, 'groupBar')"
                          [insufficientBase]="insufficientBase" [LowBase]="LowBase"></app-vertical-group-bar-chart>
                        <app-vertical-bar-chart *ngIf="isChartType(block, 'bar')" [insufficientBase]="insufficientBase"
                          [LowBase]="LowBase"></app-vertical-bar-chart>
                        <app-stackChart *ngIf="isChartType(block, 'stack')" [insufficientBase]="insufficientBase"
                          [LowBase]="LowBase"></app-stackChart>
                        <app-lineChart *ngIf="isChartType(block, 'line')" [insufficientBase]="insufficientBase"
                          [LowBase]="LowBase"></app-lineChart>
                      </div>
                    </div>

                    <div class="warnings-container"
                         *ngIf="(getMcode(block) === 2 || getMcode(block) === 3) && !isSnapshotVisible(block) && getOutputData(block) && getOutputData(block).Row && getOutputData(block).Column && !block.isAnalysisSwitching && !block.isChartClosing"
                         style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; margin-top: 15px; padding: 10px; background-color: white; border-radius: 4px; font-size: 12px; color: #555;">
                      <div class="warnings-left" style="display: flex; flex-direction: column; gap: 4px;">
                        <div style="display: flex; flex-wrap: wrap; gap: 16px;">
                          <div class="warnings-block"><b>*</b> - Indicates Low Base ({{LowBase}})</div>
                          <div class="warnings-block"><b>I/S</b> - Indicates Insufficient Sample ({{insufficientBase}})</div>
                          <div class="warnings-block"><b>NA</b> - Indicates Base = 0</div>
                        </div>
                        <div
                          *ngIf="block.is_sigtesting && block.DefaultSampleSize != 'None'"
                          style="display: flex; align-items: center; gap: 30px; margin-left: 10px; margin-top: 2px;"
                        >
                          <div style="display: flex; align-items: center; gap: 6px;">
                            <span style="width: 5px; height: 5px; background-color: #00A651; border-radius: 50%; display: inline-block; margin-top: -4px;"></span>
                            <span style="color: #00A651; font-weight: 600; margin-top: -2px;">Significantly Higher</span>
                          </div>
                          <div style="display: flex; align-items: center; gap: 6px;">
                            <span style="width: 5px; height: 5px; background-color: #E3051B; border-radius: 50%; display: inline-block; margin-top: -4px;"></span>
                            <span style="color: #E3051B; font-weight: 600; margin-top: -2px;">Significantly Lower</span>
                          </div>
                        </div>
                      </div>
                      <div class="warnings-right" *ngIf="block.is_sigtesting && block.isPairWise" style="text-align: right; max-width: 400px;">
                        <b>Note:</b> Pairwise significance is available in tables only, not in charts.
                      </div>
                      <div class="warnings-block warnings-right" *ngIf="block.isIndex && block.DefaultReferenceLevel !== 'None'" style="text-align: right; max-width: 400px;">
                        <b>Note:</b> The indexed values
                        <span style="color: #00A651; font-weight: 600;">>&nbsp;{{calcThershold('Add')}}</span>
                        are highlighted in Green<br /> while values
                        <span style="color: #E3051B; font-weight: 600;">&lt;&nbsp;{{calcThershold('minus')}}</span>
                        are highlighted in Red.
                      </div>
                    </div>
                  </div>

                  <!-- Snapshot Output -->
                  <div *ngIf="isSnapshotVisible(block)">
                    <app-output-popup-askme *ngIf="isSnapshotVisible(block) && !isFailedCase(block)"
                      [id]="(getCustomData(block)?.widget_id || filteredWidgetID) + '_' + block.messageId"
                      [snapProduct]="'custom'" [popUpParameter]="getCustomData(block)?.widget_name"
                      [customData]="getCustomData(block)" [item]="getCustomData(block)"
                      [showSnapshotARK]="isSnapshotVisible(block)" [snapshotConfig]="getSnapshotConfig(block)"
                      [masterStudyConfig]="masterStudyConfig" [isTrendActive]="!!block.isTrendActive" [block]="block"
                      (isTrendAvailableChange)="block.isTrendAvailable = $event"
                      (isSampleSizeChange)="setSampleSizeChange($event)"></app-output-popup-askme>
                  </div>

                  <!-- Insights Display -->
                  <div *ngIf="isInsightVisible(block)" class="output-insights"
                    [class.streaming-mode]="isInsightsStreaming && block.messageId === selectedMessageId"
                    [class.failed-insights]="isFailedCase(block)">
                    <div class="insights-div">
                      <div class="insights-icon">
                        <img src="../../../assets/images/explorerPlus/Insights_Icon.svg" alt="Insights">
                      </div>
                      <div class="insights-content-wrapper" style="flex: 1; display: flex; flex-direction: column; min-width: 0;">
                        <div class="insights-header" style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-bottom: 8px;">
                          <h3>{{ isFailedCase(block) && block.messageId === selectedMessageId ? (errorHeader || 'Error:') :
                            'Insights:' }}</h3>
                          <div class="insights-action-btn" [class.text-copy-success-pulse]="copiedInsightsId === block.messageId" (click)="copyInsightsToClipboard(block); $event.stopPropagation()" title="{{ copiedInsightsId === block.messageId ? 'Copied!' : 'Copy' }}">
                            <svg *ngIf="copiedInsightsId !== block.messageId" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8600cd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="insights-svg-icon">
                              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                            </svg>
                            <svg *ngIf="copiedInsightsId === block.messageId" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8600cd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="insights-svg-icon copied copied-checkmark">
                              <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                          </div>
                        </div>
                        <div class="insights-text" #insightsContainer
                          (scroll)="checkInsightsOverflow(block, insightsContainer)" style="width: 100%; flex: 1;">
                        <div class="generating-insights-text skeleton-container"
                          *ngIf="!isFailedCase(block) && block.messageId === selectedMessageId && !insightsStreamingText && getInsightsForBlock(block).length === 0" style="padding-left: 24px;">
                          <span style="margin-bottom: 8px; display: block; margin-left: -24px;">Generating insights...</span>
                          <div style="display: flex; gap: 12px; align-items: center;">
                            <div class="skeleton-line" style="width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0;"></div>
                            <div class="skeleton-line sk-w-90"></div>
                          </div>
                          <div style="display: flex; gap: 12px; align-items: center;">
                            <div class="skeleton-line" style="width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0;"></div>
                            <div class="skeleton-line sk-w-80"></div>
                          </div>
                          <div style="display: flex; gap: 12px; align-items: center;">
                            <div class="skeleton-line" style="width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0;"></div>
                            <div class="skeleton-line sk-w-100"></div>
                          </div>
                        </div>
                        <!-- Real-time streaming text display as bullet points (only for active message) -->
                        <div *ngIf="!isFailedCase(block) && block.messageId === selectedMessageId && insightsStreamingText"
                          class="streaming-insights-text">
                          <ul>
                            <li *ngFor="let point of insightsStreamingPoints; trackBy: trackByIndex" class="insight-item"
                              [innerHTML]="point | formatMarkdown: true"></li>
                          </ul>
                        </div>
                        <!-- Completed insights display (Historical or Finished Active) -->
                        <div
                          *ngIf="!isFailedCase(block) && (block.messageId !== selectedMessageId || !insightsStreamingText) && getInsightsForBlock(block).length > 0"
                          class="completed-insights-text">
                          <ul>
                            <li *ngFor="let detail of getInsightsForBlock(block); let i = index; trackBy: trackByIndex" class="insight-item"
                              [style.animation-delay.ms]="i * 300" [innerHTML]="detail | formatMarkdown: true"></li>
                          </ul>
                        </div>
                        <p *ngIf="isFailedCase(block) && block.messageId === selectedMessageId"
                          [innerHTML]="getInsightsForBlock(block) | formatMarkdown"></p>
                      </div>
                      </div>

                      <!-- Custom Scroll Buttons -->
                      <div class="insights-scroll-controls" *ngIf="block.isInsightsOverflowing">
                        <button class="insight-scroll-btn up" (click)="scrollInsights('up', block, insightsContainer)"
                          [class.disabled]="block.isAtTop">
                          <span class="arrow-up"></span>
                        </button>
                        <button class="insight-scroll-btn down"
                          (click)="scrollInsights('down', block, insightsContainer)"
                          [class.disabled]="block.isAtBottom">
                          <span class="arrow-down"></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /table-output-wrapper -->
              </div>

              <div class="question-divider"
                *ngIf="block.messageId === selectedMessageId && ((isChatAreaVisible && selectedMessageId) || arktabaccess)">
              </div>
            <!-- AI Response Text with Actions (outside wrapper) -->
            <!-- AI Response Text with Actions -->
            <div class="output-ai-response"
              *ngIf="(block.messageId === selectedMessageId || block.fullAnswer) && getCurrentQnAResponse(block)">
              <div class="response-content-wrapper">
                <div class="askme-logo-container">
                  <img src="/assets/ImagesAskme/AskMe_Logo.svg" alt="AskMe">
                </div>
                <div class="response-text-container">
                  <div class="generating-insights-text skeleton-container" *ngIf="getCurrentQnAResponse(block) === 'Answering question...'">
                    <span style="margin-bottom: 4px; display: block;">Answering question...</span>
                    <div class="skeleton-line sk-w-60"></div>
                  </div>
                  <div class="output-response-text" *ngIf="getCurrentQnAResponse(block) !== 'Answering question...'" [innerHTML]="getCurrentQnAResponse(block) | formatMarkdown"></div>

                  <div class="response-actions-row">
                    <div class="action-icons">
                      <div class="like-icon-wrapper tooltip-wrapper">
                        <div class="icon-button like-icon" [class.liked]="block.isLiked === true"
                          (click)="onLikeClick(block); $event.stopPropagation()"></div>
                        <div class="askme-custom-tooltip feedback-tooltip">
                          <span class="d-title">{{ block.isLiked === true ? 'Remove feedback' : 'Good response' }}</span>
                        </div>

                        <!-- Feedback box for like -->
                        <div class="feedback-box" *ngIf="block.showLikeInput"
                          (click)="$event.stopPropagation()" #likeFeedbackBox>
                          <div class="feedback-content">
                            <p class="feedback-label">What did you like?</p>
                            <div class="feedback-input-wrapper">
                              <input type="text" class="feedback-input"
                                placeholder="Tell us what worked well..." [(ngModel)]="block.likeReason"
                                (keyup.enter)="submitLikeFeedback(block)" #likeInput />
                              <div class="feedback-actions">
                                <div class="feedback-submit-btn" (click)="submitLikeFeedback(block)">
                                  <div class="submit-icon-css"></div>
                                </div>
                                <div class="feedback-cancel-btn" (click)="cancelLikeFeedback(block)">
                                  <div class="cancel-icon-css"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="dislike-icon-wrapper tooltip-wrapper">
                        <div class="icon-button dislike-icon" [class.disliked]="block.isLiked === false"
                          (click)="onDislikeClick(block); $event.stopPropagation()"></div>
                        <div class="askme-custom-tooltip feedback-tooltip">
                          <span class="d-title">{{ block.isLiked === false ? 'Remove feedback' : 'Bad response' }}</span>
                        </div>

                        <!-- Feedback box for dislike -->
                        <div class="feedback-box" *ngIf="block.showDislikeInput"
                          (click)="$event.stopPropagation()" #dislikeFeedbackBox>
                          <div class="feedback-content">
                            <p class="feedback-label">What went wrong?</p>
                            <div class="feedback-input-wrapper">
                              <input type="text" class="feedback-input"
                                placeholder="Tell us what could be improved..." [(ngModel)]="block.dislikeReason"
                                (keyup.enter)="submitDislikeFeedback(block)" #dislikeInput />
                              <div class="feedback-actions">
                                <div class="feedback-submit-btn" (click)="submitDislikeFeedback(block)">
                                  <div class="submit-icon-css"></div>
                                </div>
                                <div class="feedback-cancel-btn" (click)="cancelDislikeFeedback(block)">
                                  <div class="cancel-icon-css"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="star-icon-wrapper tooltip-wrapper">
                        <div class="icon-button star-icon" [class.starred]="block.isStarred"
                          (click)="toggleStarred(block)"></div>
                        <div class="askme-custom-tooltip feedback-tooltip">
                          <span class="d-title">{{ block.isStarred ? 'Unsave response' : 'Save response' }}</span>
                        </div>
                      </div>
                      <div class="copy-icon-wrapper tooltip-wrapper">
                        <div class="icon-button text-copy-btn" [class.text-copy-success-pulse]="copiedResponseId === block.messageId" (click)="copyFullResponse(block); $event.stopPropagation()" style="transition: all 0.3s ease;">
                          <svg *ngIf="copiedResponseId !== block.messageId" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="copy-svg-icon" style="pointer-events: none;">
                            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                          </svg>
                          <!-- Copied Checkmark Icon -->
                          <svg *ngIf="copiedResponseId === block.messageId" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="copy-svg-icon copied copied-checkmark" style="pointer-events: none; transform-origin: center;">
                            <polyline points="20 6 9 17 4 12"></polyline>
                          </svg>
                        </div>
                        <div class="askme-custom-tooltip feedback-tooltip">
                          <span class="d-title">{{ copiedResponseId === block.messageId ? 'Copied!' : 'Copy response' }}</span>
                        </div>
                      </div>
                      <div class="delete-icon-wrapper tooltip-wrapper">
                        <div class="icon-button trash-icon" (click)="onDeleteClick(block); $event.stopPropagation()"></div>
                        <div class="askme-custom-tooltip feedback-tooltip">
                          <span class="d-title">Delete response</span>
                        </div>
                        <div class="delete-confirm-box" *ngIf="block.showDeleteConfirm"
                          (click)="$event.stopPropagation()" #deleteConfirmBox>
                          <div class="delete-confirm-content">
                            <div class="delete-confirm-header">
                              <div class="warning-triangle"></div>
                              <p class="delete-confirm-label">Permanently delete?</p>
                            </div>
                            <p class="delete-confirm-subtext">This will remove the message from your history.</p>
                            <div class="delete-confirm-actions">
                              <button class="delete-cancel-btn-new" (click)="cancelDelete(block)">Cancel</button>
                              <button class="delete-confirm-btn-new" (click)="confirmDelete(block)">
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p class="ai-disclaimer">*Response is generated by AI. Please check important information.</p>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
        <!-- Dynamic scroll spacer to allow scrolling the last question to the top -->
        <div class="chat-scroll-spacer" [style.height.px]="scrollSpacerHeight"></div>
      </div>

      <!-- Footer - Always outside the white output area, inside chat-container -->
      <div class="footer">
        <div class="footer-center" style="display: flex; flex-direction: column; width: 100%; max-height: 100%;">
          <div class="askme-container" style="display: flex; flex-direction: column; width: 100%; align-items: center; max-height: 100%; position: relative; z-index: 1000; flex: 1; min-height: 0;">
            <!-- MULTI QUESTION UI -->
            <div class="multi-question-panel" *ngIf="isMultiQuestionMode">
              <div class="mq-header">
                <div style="display: flex; align-items: center; gap: 8px;">
                  <span>Batch Questions</span>
                </div>
                <div class="mq-close" (click)="toggleMultiQuestionMode()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                </div>
              </div>
              <div class="mq-list">
                <div class="mq-item" *ngFor="let q of multiQuestionList; let i = index; trackBy: trackByIndex">
                  <span class="mq-number">{{i + 1}}.</span>
                  <input type="text" [value]="multiQuestionList[i]" (input)="multiQuestionList[i] = $any($event.target).value" placeholder="Enter question..." class="mq-input" (keydown.enter)="addMultiQuestion()">
                  <div class="mq-remove" (click)="removeMultiQuestion(i)" *ngIf="multiQuestionList.length > 1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                  </div>
                </div>
              </div>
              <div class="mq-actions">
                <input type="file" #excelUpload2 style="display: none" accept=".xlsx, .xls, .csv" (change)="onBatchExcelUpload($event)">
                <div style="display: flex; gap: 8px;">
                  <button class="mq-upload-btn" (click)="promptForTemplate(excelUpload2)">Upload Excel</button>
                  <button class="mq-add-btn" (click)="addMultiQuestion()">+ Add Question</button>
                </div>
                <button class="mq-send-btn" [disabled]="!hasValidMultiQuestions" (click)="sendMultiQuestions()">Send All ({{multiQuestionList.length}})</button>
              </div>

              <!-- Template Download Prompt Overlay -->
              <div class="template-prompt-overlay" *ngIf="showTemplatePrompt">
                <div class="template-prompt-card">
                  <div class="prompt-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8600cd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
                  </div>
                  <h4>Download Template?</h4>
                  <p>Use standard format for a seamless upload.</p>
                  <div class="template-prompt-actions">
                    <button class="btn-outline" (click)="handleTemplateSelection(true)">Yes, Download</button>
                    <button class="btn-primary" (click)="handleTemplateSelection(false)">Skip & Upload</button>
                  </div>
                  <div class="prompt-close" (click)="showTemplatePrompt = false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                  </div>
                </div>
              </div>
            </div>

            <div class="search-box" [class.search-box-blurred]="arktabaccess"
              [ngStyle]="{'pointer-events': isAnyLoaderActive ? 'none' : 'auto', 'opacity': isAnyLoaderActive ? '0.6' : '1'}">
              <form [formGroup]="searchForm" (ngSubmit)="onSearchSubmit()" class="search-form">
                <div class="search-input-wrapper" [style.visibility]="isScrollingToTarget ? 'hidden' : 'visible'">
                <input type="text" formControlName="query" 
                       [placeholder]="isDictating && activeDictationTarget === 'main' ? 'Listening...' : 'Ask me anything...'" 
                       class="search-input"
                       [attr.disabled]="isAnyLoaderActive ? true : null" />
                       
                <!-- Multi Question Toggle -->
                <div class="dictate-icon-wrapper multi-q-toggle" (click)="toggleMultiQuestionMode()">
                  <div class="dictate-icon" [class.recording]="isMultiQuestionMode">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-list-todo"><rect x="3" y="5" width="6" height="6" rx="1"/><path d="m3 17 2 2 4-4"/><path d="M13 6h8"/><path d="M13 12h8"/><path d="M13 18h8"/></svg>
                  </div>
                  <div class="askme-custom-tooltip">
                    <span class="d-title">Batch Questions</span>
                  </div>
                </div>

                <!-- Dictation Mic -->
                <div class="dictate-icon-wrapper" *ngIf="isSpeechSupported">
                  <div class="dictate-icon" 
                       [class.recording]="isDictating && activeDictationTarget === 'main'"
                       (click)="toggleDictation('main')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-mic"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" x2="12" y1="19" y2="22"/></svg>
                  </div>
                  <div class="askme-custom-tooltip">
                    <span class="d-title">Dictate</span>
                    <span class="d-shortcut">Ctrl + Shift + D</span>
                  </div>
                </div>
              </div>
              <div class="send-icon-wrapper" [style.visibility]="isScrollingToTarget ? 'hidden' : 'visible'">
                  <button type="submit" class="send-button">
                    <div class="send-arrow"></div>
                  </button>
                  <div class="askme-custom-tooltip">
                    <span class="d-title">Send</span>
                    <span class="d-shortcut">Enter</span>
                  </div>
                </div> 
            </form>
          </div>
        </div>
        </div>
        <div class="powered-by" [class.powered-by-glow]="arktabaccess">
          <span class="powered-text">Powered by</span>
          <div class="kai-logo"></div>
        </div>
        <div class="explorer-logo"></div>
      </div>

      <!-- Selection Summary Component -->
      <div class="selection-summary-component" *ngIf="isselectionsummarycollapse">
        <div class="overLay visible" (click)="OnCloseClick()"></div>
        <div class="selection-summary-container" [class.visible]="isselectionsummarycollapse2">
          <div class="selection-summary-block">
            <div class="selection-header">
              <div class="selection-text">{{isselectionHeader}}</div>
              <div class="selection-icon" (click)="OnCloseClick()">
                <div class="icon1"></div>
              </div>
            </div>
            <div class="summary-view" *ngIf="!isSummaryForSnapshot">
              <div class="summary-view-outer">
                <div class="summary-header">Study Type</div>
                <div class="selection-summary-view-text">
                  <div class="selection-header-container">
                    <span class="selection-key">Study Type:</span>
                    <span class="selection-value">{{selected_study}}</span>
                  </div>
                </div>

                <div class="summary-header">Column</div>
                <div class="selection-summary-view-text">
                  <div *ngFor="let selection of Columnselections; trackBy: trackByIndex" class="selection-header-container">
                    <span class="selection-key">{{selection.key}}:</span>
                    <span class="selection-value">{{selection.value}}</span>
                  </div>
                </div>

                <div class="summary-header">Row</div>
                <div class="selection-summary-view-text">
                  <div *ngFor="let selection of Rowselections; trackBy: trackByIndex" class="selection-header-container">
                    <span class="selection-key">{{selection.key}}:</span>
                    <span class="selection-value">{{selection.value}}</span>
                  </div>
                </div>

                <div class="summary-header">Filters</div>
                <div class="selection-summary-view-text">
                  <div *ngFor="let selection of AllSelections; trackBy: trackByIndex" class="selection-header-container">
                    <span class="selection-key">{{selection.key}}:</span>
                    <span class="selection-value">{{selection.value}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="summary-view" *ngIf="isSummaryForSnapshot && !failedCase">
              <div class="summary-view-outer">
                <!-- Compare Across section -->
                <div class="summary-header">Compare Across</div>
                <div class="selection-summary-view-text">
                  <div *ngFor="let title of titleSection; trackBy: trackByIndex" class="selection-header-container">
                    <span class="selection-key">{{title.key}}:</span>
                    <span class="selection-value">{{title.value}}</span>
                  </div>
                </div>

                <!-- Entry Point section -->
                <div class="summary-header" *ngIf="entryPoints.length > 0">Entry Point</div>
                <div class="selection-summary-view-text">
                  <div *ngFor="let entry of entryPoints; trackBy: trackByIndex" class="selection-header-container">
                    <span class="selection-key">{{entry.key}}:</span>
                    <span class="selection-value">{{entry.value}}</span>
                  </div>
                </div>

                <!-- Selections section -->
                <div class="summary-header">Selections</div>
                <div class="selection-summary-view-text">
                  <div *ngFor="let selection of selections; trackBy: trackByIndex" class="selection-header-container">
                    <span class="selection-key">{{selection.key}}:</span>
                    <span class="selection-value">{{selection.value}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Chat History Overlay -->
  <div class="chat-history-overlay" [class.closing]="isClosing" *ngIf="isChatHistoryOpen"
    (click)="onCloseChatHistory()">
    <div class="chat-history-modal" [class.closing]="isClosing" (click)="$event.stopPropagation()">
      <div class="chat-history-header">
        <h2 class="chat-history-title">Chats</h2>
        <div class="header-controls" (click)="onBackClickChatHistory()">
          <div class="filter-back-icon"></div>
        </div>
      </div>
      <div class="chat-search-section">
        <div class="chat-combined-search-box" [class.nested-active]="isNestedSearchVisible && chatSearchText">
          <div class="chat-search-input-wrapper">
            <input type="text" class="chat-search-input" placeholder="Search Chats" [(ngModel)]="chatSearchText"
              (input)="onChatSearch()" />
            <div class="search-icon"></div>
            <div class="nested-search-toggle tooltip-wrapper"
              *ngIf="(chatSearchText && primaryFilteredCount > 1) || isNestedSearchVisible"
              [class.active]="isNestedSearchVisible" (click)="toggleNestedSearch()">
              <svg *ngIf="!isNestedSearchVisible" width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
              </svg>
              <span *ngIf="isNestedSearchVisible" class="toggle-close">✕</span>
              <div class="askme-custom-tooltip"><span class="d-title">Filter</span></div>
            </div>
          </div>
          <div class="chat-nested-input-row" *ngIf="isNestedSearchVisible && chatSearchText">
            <span class="nested-node-icon">➝</span>
            <input type="text" class="chat-nested-input" placeholder="Search within these chats..."
              [(ngModel)]="chatNestedSearchText" (input)="onChatSearch()" />
          </div>
        </div>
      </div>
      <div class="chat-accordion-section">
        <ng-container *ngFor="let group of chatAccordions; trackBy: trackByIndex">
      <div class="month-group-header" (click)="toggleMonthGroup(group)">
        <span class="month-chevron" [class.expanded]="group.isExpanded"></span>
          {{ group.month }}
        </div>
      <div class="chat-accordion-list month-group-list" *ngIf="group.isExpanded">
            <div class="chat-accordion-item" [class.expanded]="item.isExpanded || item.isCollapsing"
              *ngFor="let item of group.chats; trackBy: trackByIndex">
            <div class="accordion-header" (click)="toggleAccordion(item)">
              <div class="question-icon-wrapper">
                <div class="accordion-icon" [class.expanded]="item.isExpanded">
                  <div class="collapse-icon" *ngIf="item.isExpanded"></div>
                  <div class="expand-icon" *ngIf="!item.isExpanded"></div>
                </div>
              </div>
              <div class="accordion-questions-list">
                <p class="accordion-main-question">{{ item.mainQuestion }}</p>
              </div>
              <div class="delete-chat-icon tooltip-wrapper" (click)="initiateDeleteChat($event, item)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#a0a0a0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash-2"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>
                <div class="askme-custom-tooltip"><span class="d-title">Delete Chat</span></div>
              </div>
            </div>
            <div class="accordion-content" [class.closing]="item.isCollapsing"
              *ngIf="item.isExpanded || item.isCollapsing">
              <div class="accordion-sub-questions" *ngIf="item.questions.length > 0">
                <div class="accordion-sub-question-item" *ngFor="let question of item.questions; let i = index; trackBy: trackByIndex"
                  [style.animation-delay]="(i * 0.05) + 's'"
                  (click)="getChatResponse(question.MessageId)">
                  <p class="sub-question-text">{{ question.Question }}</p>
                  <p class="accordion-answer-preview" *ngIf="question.AnswerPreview">{{ question.AnswerPreview }}</p>
                </div>
              </div>
            </div>
          </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>


  <!-- Saved Questions Overlay -->
  <div class="saved-questions-overlay" [class.closing]="isClosing" *ngIf="isSavedQuestionsOpen"
    (click)="onCloseSavedQuestions()">
    <div class="saved-questions-modal" [class.closing]="isClosing" (click)="$event.stopPropagation()">
      <div class="saved-questions-header">
        <h2 class="saved-questions-title">Saved Questions</h2>
        <div class="header-controls" (click)="onBackClickSavedQuestions()">
          <div class="filter-back-icon"></div>
        </div>
      </div>

      <div class="saved-questions-search-section">
        <div class="saved-questions-search-input-wrapper">
          <input type="text" class="saved-questions-search-input" placeholder="Search Saved Questions"
            [(ngModel)]="starredSearchText" (input)="onStarredSearch()" />
          <div class="search-icon"></div>
        </div>
      </div>

      <!-- Loading State -->
      <div class="saved-questions-loading" *ngIf="isLoadingStarredMessages">
        <div class="loading-spinner"></div>
      </div>

      <!-- Empty State -->
      <div class="empty-state-section" *ngIf="!isLoadingStarredMessages && filteredStarredMessages.length === 0">
        <div class="empty-state-icon">⭐</div>
        <h3 class="empty-state-title">No Questions Saved</h3>
        <p class="empty-state-description">Saved questions in chats will appear here</p>
      </div>

      <!-- Starred Messages List -->
      <div class="saved-questions-list-section" *ngIf="!isLoadingStarredMessages && filteredStarredMessages.length > 0">
        <div class="saved-questions-list">
          <div class="saved-question-item" *ngFor="let message of filteredStarredMessages; trackBy: trackByIndex"
            (click)="onStarredQuestionClick(message)">
            <div class="saved-question-icon">
              <div class="star-filled-icon"></div>
            </div>
            <div class="saved-question-content" style="flex-direction: column; align-items: flex-start; justify-content: center; gap: 0.35em;">
              <p class="saved-question-text" style="width: 100%;">{{ message.Question }}</p>
              <p class="accordion-answer-preview" *ngIf="message.AnswerPreview" style="margin-top: 0; width: 100%;">{{ message.AnswerPreview }}</p>
            </div>
            <div class="saved-question-actions">
              <div class="icon-button star-icon starred" (click)="unstarFromSaved(message, $event)"></div>
              <div class="icon-button trash-icon" (click)="deleteFromSaved(message, $event)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Combined Loading Overlay -->
  <div class="ai-minimal-loader-overlay" *ngIf="arktabaccess && !(_loaderService.isLoading$ | async)">
    <div class="chatbot-loader-icon"></div>
    <div class="ai-status-pill">
      <div class="ai-status-text">
        <span class="shimmer-text">
          {{ (isStreamFinished && statusQueue.length === 0) ? getPostStreamMessage() : (streamStatusText ||
          (currentQueryForStream
          ? 'Processing: ' +
          truncateText(currentQueryForStream, 50) : 'Initializing analysis')) }}
        </span>
        <span class="typing-dots"><span>.</span><span>.</span><span>.</span></span>
      </div>
    </div>
  </div>

  <!-- Toast Notification -->
  <div class="toast-notification" *ngIf="showToastNotification" 
    [class.success]="toastType === 'success'"
    [class.error]="toastType === 'error'" 
    [class.info]="toastType === 'info'"
    [class.paused]="isToastHovered"
    (mouseenter)="onToastMouseEnter()"
    (mouseleave)="onToastMouseLeave()">
    <div class="toast-content">
      <div class="toast-icon-container">
        <div class="toast-icon-css"></div>
      </div>
      <div class="toast-text-wrapper">
        <div class="toast-title" *ngIf="toastType === 'success'">Success</div>
        <div class="toast-title" *ngIf="toastType === 'error'">Error</div>
        <div class="toast-title" *ngIf="toastType === 'info'">Information</div>
        <div class="toast-message">{{ toastMessage }}</div>
      </div>
      <div class="toast-close-btn" (click)="showToastNotification = false">
        <div class="close-icon-css"></div>
      </div>
    </div>
    <div class="toast-progress"></div>
  </div>

  <!-- Chat Session Delete Confirmation Modal -->
  <div class="delete-chat-modal-overlay" *ngIf="chatToDelete" (click)="cancelDeleteChat()">
    <div class="delete-chat-modal" (click)="$event.stopPropagation()">
      
      <div class="delete-chat-icon-container">
        <div class="icon-circle">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#dc3545" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash-2"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>
        </div>
      </div>

      <div class="delete-chat-content">
        <h3>Delete Chat Session?</h3>
        <p>This will permanently delete the entire chat and all its questions. This action cannot be undone.</p>
      </div>

      <div class="delete-chat-actions">
        <button class="delete-cancel-btn-premium" (click)="cancelDeleteChat()" [disabled]="isDeletingChat">Cancel</button>
        <button class="delete-confirm-btn-premium" (click)="confirmDeleteChatSession()" [disabled]="isDeletingChat" [class.loading]="isDeletingChat">
          <span *ngIf="!isDeletingChat">Delete</span>
          <span *ngIf="isDeletingChat" class="loading-text">
            Deleting...
          </span>
        </button>
      </div>
      
    </div>
  </div>

</div>
